import { Fragment, type FC } from 'react';

import { ThrowError } from '#apps/client-web/app/components/throw-error';

import { type LoggingContext } from '#packages/data-collection/types/logging-context';
import { type ViewModelProps } from '#packages/web/types/view-model-props';
import { LoadingPage } from '#packages/web/layouts/page/templates';

import { AuditDetailsUploadDialog } from '../audit-details/audit-details-upload-dialog';
import { type AuditReviewSubmitPageViewModel } from './audit-review-submit-page.view-model';
import { AuditReviewSubmitPageRenderer } from './audit-review-submit-page.renderer';

export type AuditReviewSubmitPageContainerProps =
  ViewModelProps<AuditReviewSubmitPageViewModel> & LoggingContext;

export const AuditReviewSubmitPageContainer: FC<
  AuditReviewSubmitPageContainerProps
> = ({ viewModel }) => {
  const {
    page,
    uploadState,
    uploadDialog,
    uploadMutationState,
    isUploadSuccess,
    resetUploadState,
    onUpload,
    onUploadConfirm,
  } = viewModel;

  return (
    <Fragment>
      {/* Loading */}
      {page.state === 'loading' && <LoadingPage />}

      {/* Success */}
      {page.state === 'success' && (
        <AuditReviewSubmitPageRenderer
          formEntries={page.data.formEntries}
          onUpload={onUpload}
        />
      )}

      {/* Error */}
      {page.state === 'error' && <ThrowError error={page.error} />}

      {/* Upload Dialog */}
      {uploadDialog.isOpen && uploadDialog.data && (
        <AuditDetailsUploadDialog
          audit={uploadDialog.data}
          uploadState={uploadState}
          uploadMutationState={uploadMutationState}
          isUploadSuccess={isUploadSuccess}
          resetUploadState={resetUploadState}
          onClose={uploadDialog.close}
          onUpload={onUploadConfirm}
        />
      )}
    </Fragment>
  );
};
